import React from 'react';
import { Link, Navigate } from 'react-router-dom';
import strings from '../../components/Language';
import AuthHeader from '../../components/Layout/AuthHeader';
import api from '../../config/api';
import OtpInput from 'react-otp-input';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Button } from 'antd';
import PublicFooter from '../../components/Layout/PublicFooter';

class LoginScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: strings.getLanguage(),
            isAuthenticated: false,
            username: '',
            password: '',
            otp: '',
            errorMessage: [],
            isLoading: false,
        }
    }

    async componentDidMount() { }

    handleLogin = () => {
        const self = this;
        self.setState({ isLoading: true });
        axios({
            method: 'POST',
            url: api.Login,
            data: {
                username: self.state.username ?? '',
                password: self.state.otp ?? '',
            },
            headers: {
                'Content-Type': 'multipart/form-data;',
                'Accept-Language': self.state.lang,
            }
        }).then(async function (ress) {
            self.setState({ isLoading: false });
            if (ress.data.error == 202 || ress.data.error == '202') {
                if (ress.data.errors && ress.data.errors.length != 0) {
                    self.setState({ errorMessage: ress.data.errors });
                } else {
                    toast.error(ress.data.message);
                }
            } else {
                await localStorage.setItem('user_token', (ress.data.access_token) ? ress.data.access_token : '');
                await localStorage.setItem('isAuthenticated', true);
                toast.success(strings["Login successfully!"]);
                self.setState({ isAuthenticated: true });
                return <Navigate to="/" />;
            }
        }).catch(function (err) {
            if (err && err.response && (err.response.status == 422)) {
                if (err && err.response && err.response.data && err.response.data.errors) {
                    self.setState({ errorMessage: err.response.data.errors });
                }
            }
            if (err && err.response && err.response.data && (err.response.data.error === '202' || err.response.data.error === 202)) {
                let msg = err.response.data && err.response.data.message ? err.response.data.message : strings.something_wrong;
                toast.error(msg);
            } else {
                toast.error(strings.invalid_login_details);
            }
            self.setState({ isLoading: false });
        });
    };

    handleChange = (otp) => {
        this.setState({ otp });
    };

    render() {
        if (this.state.isAuthenticated) {
            return <Navigate to="/" />;
        }

        const { otp } = this.state;

        return (
            <>
                <div className="login-screen">
                    <AuthHeader data={{ title: "" }} />

                    <main className="main-content">
                        <h2 id="loginTitle" className="login-title">{strings["loginTitle"]}</h2>

                        <div id="login-form">
                            <div className="form-group">
                                <label htmlFor="mobileNumPlaceholder" id="mobileNumLabel">{strings["mobileNumLabel"]}<span>*</span></label>
                                <input
                                    onChange={(e) => this.setState({ username: e.target.value })}
                                    defaultValue={this.state.username}
                                    type="tel"
                                    id={"mobileNumPlaceholder"}
                                    placeholder={strings["mobileNumPlaceholder"]}
                                    required
                                />
                                <div className='row'> {this.state.errorMessage.username && <div className='errorMessage'> {this.state.errorMessage.username[0]} </div>}</div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="digit1" id="passwordLabel">{strings["passwordLabel"]}<span>*</span></label>
                                <div className="password-code">
                                    <OtpInput
                                        value={otp}
                                        onChange={this.handleChange}
                                        numInputs={6} // Number of OTP input fields
                                        renderInput={(props) => <input {...props} />}
                                        inputStyle="password-input"
                                        inputType='password'
                                    />
                                </div>
                                <div className='row'> {this.state.errorMessage.password && <div className='errorMessage'> {this.state.errorMessage.password[0]} </div>}</div>
                            </div>

                            <Button type="submit" id="loginButton" className="login-button" loading={this.state.isLoading} onClick={this.handleLogin} >
                                {strings["loginButton"]}
                            </Button>

                            <div className="forgot-password">
                                <Link
                                    to={"/forgot-password"}
                                    id="forgotPasswordLink"
                                    style={{ color: "#000", textDecoration: "none" }}
                                >
                                    {strings["forgotPasswordLink"]}
                                </Link>
                            </div>

                            <div className="signup-prompt" id="signupPrompt">
                                {strings["signupPrompt"]} <Link to={"/signup"}>{strings["signupButton"]}</Link>
                            </div>
                        </div>
                    </main>

                    <PublicFooter />
                </div>
            </>
        );
    }
}

export default LoginScreen;
